<template>
  <a @click="passMethod()" :class="classes"></a>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';

export default {
  mixins: [themeMixins],
  props: ['active'],
};
</script>

<style scoped lang="scss"></style>
